/* istanbul ignore file */

import type { ImportsHistoryQueryVariables } from '../queries/useImportsHistory';

const ddexImport = () => [{ entity: 'ddexImport' }] as const;

const ddexImportLists = () => [{ ...ddexImport()[0], scope: 'list' }] as const;
const ddexImportList = (variables: ImportsHistoryQueryVariables) =>
  [{ ...ddexImportLists()[0], variables }] as const;

const ddexImportStatusCounts = () =>
  [{ ...ddexImport()[0], scope: 'statusCounts' }] as const;

export const ddexImportQueryKeys = {
  list: ddexImportList,
  statusCounts: ddexImportStatusCounts,
};

const ddexPermissions = () => ['ddexEnabled'] as const;

export const ddexPermissionsKeys = {
  permissions: ddexPermissions,
};
